import React from 'react';
import { Grid, Button, Dropdown, Input, Form, TextArea, Radio, Card } from 'semantic-ui-react';
import $ from "jquery";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Buttons from '@material-ui/core/Button';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import ReadCookie from '../../../functions/readcookies';
import Server from '../../../functions/server';
import Loading from '../../loadings';

const styles = {
  appBar: { position: 'relative' },
  flex: { flex: 1 },
};

function Transition(props) {
  return <Slide direction="up" {...props} />;
}

class Transfer extends React.Component {

  state = {
    data: [], selectedType: '',
    fullWidth: true, maxWidth: 'sm',
    Date: this.getFormatedDate(new Date(), 0),
    customerdropdown: '', remarks: ''
  }

  componentDidMount() {
    this.checkBranch();
  }

  

  checkBranch() {
    let data = (ReadCookie("branch"));
    let branchId;
    for (var i = 0; i < data.length; i++) {
      branchId = data[i].branch_id;
    }
    this.setState({ branchId })
    this.getPurchaserAndCustomerAndLedger(branchId);
  }

  getPurchaserAndCustomerAndLedger(branchId) {
    let context = this;
    let cook = (ReadCookie("vaigai"));
    let userId = cook.id;
    this.setState({ load: true, message: 'Getting Purchaser Details!!!!' });
    $.ajax({
      type: 'POST', data: { 'executiveId': userId, 'branchId': branchId },
      url: Server() + 'accounting/getpurchaserandcustomerandledger.php',
      success: function(data) {
        try {
          data = JSON.parse(data);
          context.setState({ data, load: false })
        } catch (e) { context.setState({ load: false }); alert('Error To Get Purchasers!!!') }
      },
      error: function(err) {
        context.setState({ load: false, });
        alert('Try again!!!!')
      }
    });
  }

  getFormatedDate(dates, interval) {
    if (interval > 0) {
      dates = new Date(dates.getTime() - (interval * 24 * 60 * 60 * 1000));
    }
    let month = dates.getMonth() + 1; let date = dates.getDate();
    month = (month > 10) ? month : "0" + month;
    date = (date > 10) ? date : "0" + date;
    let x;
    if (interval == 'fromDate') {
      x = dates.getFullYear() + "-" + month + "-01";
    }
    else {
      x = dates.getFullYear() + "-" + month + "-" + date;
    }
    return x;
  }

  onChangeType = (type) => (f, { value }) => {
    if (type == 'selectedFrom') {
      this.setState({ [type]: value, 'fromid': '', 'fromvalue': '', 'toid': '', 'tovalue': '' })
    }
    else {
      this.setState({ [type]: value, 'toid': '', 'tovalue': '' })
    }
  }

  onSelect1 = (key1) => event => {
    this.setState({ [key1]: event.target.value })
  }

  onSelect = (key1, key2) => event => {
    let val = event.target.value;
    let value = val.split('->')[0];
    this.setState({ [key1]: value,  [key2]: val })
  }

  clearAllData() {
    this.setState({
      fromledgerid: '', toledgerid: '', fromledgerdropdown: '', toledgerdropdown: '',
      customerdropdown: '', customerid: '', purchaserid: '', purchaserdropdown: '',
      Date: '', amount: '', remarks: ''
    })
  }

  transfer() {
    let context = this; 
    let cook = (ReadCookie("vaigai"));
    let userId = cook.id;
    let url;  let data = [];
    let { fromid, fromvalue, toid, selectedFrom, selectedTo, tovalue, amount, remarks, Date, branchId } = this.state;
    let remark = remarks;
    let date = Date;
    let mode = tovalue.split('->')[1];
    let mode1 = fromvalue.split('->')[1];
    if (selectedFrom == 'Customer') {
      if (selectedTo == 'Customer') {
        url = Server() + 'Accountings/CustomerTransaction/CustomerToCustomerTransaction.php';
        data = { amount, 'fromcid': fromid, 'tocid': toid, remark, date, branchId };
      }
      if (selectedTo == 'Ledger') {
        url = Server() + 'receipt/insert.php';
        amount = amount * -1;
        data = { amount, 'modeid': toid, mode, 'cid': fromid, remark, date, branchId };
      }
    }
    if (selectedFrom == 'Machine Customer') {
      url = Server() + 'machine/receipt/insert.php';
      amount = amount * -1;
      data = { amount, 'ledgerid': toid, mode, 'type': 'Receipt', 'customerid': fromid, remarks, date, branchId };
    }
    if (selectedFrom == 'Purchaser') {
      url = Server() + 'purchasedetail/addreceipt.php';
      data = { amount, 'modeid': toid, 'mode': mode, 'id': fromid, remark, date, branchId };
    }
    if (selectedFrom == 'Ledger') {
      if (!selectedTo) { alert('Select Tranfer To!!!'); return; }
      else if (selectedTo == 'Purchaser') {
        url = Server() + 'purchasedetail/addpayment.php';
        data = { amount, 'modeid': fromid, mode, 'id': toid, remark, date, branchId };
      }
      else if (selectedTo == 'Customer') {
        url = Server() + 'receipt/insertpayment.php';
        data = { amount, 'modeid': fromid, 'mode': mode1, 'cid': toid, remark, date, branchId };
      }
      else if (selectedTo == 'Ledger') {
        url = Server() + 'ledger/transfer.php';
        data = { amount, remarks, 'fromledger': fromid, 'toledger': toid, 'transferedby': 1, date, branchId };
      }
      else if (selectedTo == 'Machine Customer') {
        url = Server() + 'machine/receipt/insert.php';
        data = { amount, 'ledgerid': fromid, mode, 'type': 'Payment', 'customerid': toid, remarks, date, branchId };
      }
      else if (selectedTo == 'Expense') {
        url = Server() + 'expensedetail/modetoexpense.php';
        let toSelectedPurchaser = 0;
        let toSelectedEmployee = 0;
        let toSelectedCustomer = 0;
        let fromSelectedMode = fromid;
        let toSelectedExpense = toid;
        let currentBranch = branchId;
  
        if (this.state.refrence) {
  
          if (this.state.refrence == 'Customer') {
            toSelectedCustomer = this.state.refrenceid;
          }
          if (this.state.refrence == 'Employee') {
            toSelectedEmployee = this.state.refrenceid;
          }
          if (this.state.refrence == 'Purchaser') {
            toSelectedPurchaser = this.state.refrenceid;
          }
        }
        data = { remarks, date, amount, currentBranch, userId, toSelectedPurchaser, toSelectedEmployee, toSelectedCustomer, fromSelectedMode, toSelectedExpense };
      }
    }
    this.setState({ load: true, message: 'Transferring!!!' });
    $.ajax({
      type: 'POST', url, data,
      success: function(data) {
        if (data == 1) {
          context.setState({ amount: '', remarks: '', load: false })
        }
        else {
          alert('Error')
          context.setState({ load: false })
        }
      },
      error: function(err) {
        context.setState({ load: false, });
        alert('Try again!!!!')
      }
    });
  }

  textHandle = (key) => event => { this.setState({ [key]: event.target.value }) }

  openTransfer = () => {
    this.setState({ openDialog: true })
  }

  render() {
    const { classes } = this.props;

    let typeOption1 = [
      { key: 'Customer', text: 'Customer', value: 'Customer' },
      { key: 'Machine Customer', text: 'Machine Customer', value: 'Machine Customer' },
      { key: 'Purchaser', text: 'Purchaser', value: 'Purchaser' },
      { key: 'Ledger', text: 'Ledger', value: 'Ledger' },
    ];

    if (this.props.type == 'Customer') {
      typeOption1 = [
        { key: 'Customer', text: 'Customer', value: 'Customer' },
      ];
    }
    if (this.props.type == 'Purchaser') {
      typeOption1 = [
        { key: 'Purchaser', text: 'Purchaser', value: 'Purchaser' },
      ];
    }
    if (this.props.type == 'Ledger') {
      typeOption1 = [
        { key: 'Ledger', text: 'Ledger', value: 'Ledger' },
      ];
    }
    if (this.props.type == 'Machine Customer') {
      typeOption1 = [
        { key: 'Machine Customer', text: 'Machine Customer', value: 'Machine Customer' },
      ];
    }
  
    let typeOption2 = [
      { key: 'Customer', text: 'Customer', value: 'Customer' },
      { key: 'Machine Customer', text: 'Machine Customer', value: 'Machine Customer' },
      { key: 'Purchaser', text: 'Purchaser', value: 'Purchaser' },
      { key: 'Ledger', text: 'Ledger', value: 'Ledger' },
      { key: 'Expense', text: 'Expense', value: 'Expense' },
    ];

    if (this.state.selectedFrom != 'Ledger') {
      typeOption2 = [
        { key: 'Ledger', text: 'Ledger', value: 'Ledger' },
      ];
    }

    if (this.state.selectedFrom == 'Customer') {
      typeOption2 = [
        { key: 'Ledger', text: 'Ledger', value: 'Ledger' },
        { key: 'Customer', text: 'Customer', value: 'Customer' },
      ];
    }

    return (
      <div>
        <Loading load={this.state.load} message={this.state.message} />
        <Button style={{display: this.props.transferControl}} onClick={this.openTransfer}>Transfer</Button>
        <Dialog fullWidth={this.state.fullWidth} maxWidth={this.state.maxWidth} open={this.state.openDialog}
          onClose={ () => { this.setState({ openDialog: false }) }}
          aria-labelledby="max-width-dialog-title" >
          <DialogTitle id="max-width-dialog-title">Journal</DialogTitle>
            <DialogContent>
              <div style={{padding: '3%'}}>
                <Grid>
                  <Grid.Column mobile={16} tablet={16} computer={8}>
                    <b>From</b><br/>
                    <Dropdown fluid onChange={this.onChangeType('selectedFrom')}
                      selection options={typeOption1} style={{marginBottom: '2%'}} value={this.state.selectedFrom}  />
                  </Grid.Column>
                  <Grid.Column mobile={16} tablet={16} computer={8}>
                    <b>To</b><br/>
                    <Dropdown fluid onChange={this.onChangeType('selectedTo')}
                        selection options={typeOption2} style={{marginBottom: '2%'}} value={this.state.selectedTo}  />
                  </Grid.Column>
                </Grid>
                <Form>
                  <Grid>
                    <Grid.Column mobile={16} tablet={16} computer={8}>
                      <b>{"From "+this.state.selectedFrom}</b>
                      <datalist id={"From"+this.state.selectedFrom}>
                        {this.state.data.map((y) => {
                          if (y.type == this.state.selectedFrom) {
                            return (<option id='box'>{y.id+'->'+y.name}</option>)
                          }
                        })}
                      </datalist>
                      <input style={{height: 35}} onChange={this.onSelect('fromid', 'fromvalue')} 
                      autoComplete="on" list={"From"+this.state.selectedFrom} value={this.state.fromvalue} />
                    </Grid.Column>
                    <Grid.Column mobile={16} tablet={16} computer={8}>
                      <b>{"To "+this.state.selectedTo}</b>
                      <datalist id={"To"+this.state.selectedTo}>
                        {this.state.data.map((y) => {
                          if (y.type == this.state.selectedTo) {
                            return (<option id='box'>{y.id+'->'+y.name}</option>)
                          }
                        })}
                      </datalist>
                      <input style={{height: 35}} onChange={this.onSelect('toid', 'tovalue')} 
                      autoComplete="on" list={"To"+this.state.selectedTo} value={this.state.tovalue} />
                    </Grid.Column>
                  </Grid>
                  { 
                    this.state.selectedTo == 'Expense' ?
                    (
                      <Grid>
                        <Grid.Column mobile={16} tablet={16} computer={8}>
                          <b>{"Refrence"}</b>
                          <datalist id={"Refrence"}>
                            <option id='box'>{"Customer"}</option>
                            <option id='box'>{"Employee"}</option>
                            <option id='box'>{"Purchaser"}</option>
                          </datalist>
                          <input style={{height: 35}} onChange={this.onSelect1('refrence')} 
                          autoComplete="on" list={"Refrence"} value={this.state.refrence} />
                        </Grid.Column>
                        <Grid.Column mobile={16} tablet={16} computer={8}>
                          <b>{this.state.refrence}</b>
                          <datalist id={this.state.refrence}>
                            {this.state.data.map((y) => {
                              if (y.type == this.state.refrence) {
                                return (<option id='box'>{y.id+'->'+y.name}</option>)
                              }
                            })}
                          </datalist>
                          <input style={{height: 35}} onChange={this.onSelect('refrenceid', 'refrencevalue')} 
                          autoComplete="on" list={this.state.refrence} value={this.state.refrencevalue} />
                        </Grid.Column>
                      </Grid>
                    ): null
                  }
                  <Grid>
                    <Grid.Column mobile={16} tablet={16} computer={8}>
                      <div>
                        Select Date<br/>
                        <input type="date" style={{width: '100%'}} value={this.state.Date} 
                        onChange={this.textHandle('Date')} />
                      </div>
                    </Grid.Column>
                    <Grid.Column mobile={16} tablet={16} computer={8}>
                      <div>
                        Enter Amount<br/>
                        <Input style={{width: '100%'}} placeholder='Amount' 
                        value={this.state.amount} onChange={this.textHandle('amount')} />
                      </div>
                    </Grid.Column>
                    <Grid.Column mobile={16} tablet={16} computer={16}>
                      <TextArea placeholder='Remarks' value={this.state.remarks} onChange={this.textHandle('remarks')}  /><br/>
                    </Grid.Column>
                  </Grid>
                </Form>
              </div>
            </DialogContent>
            <DialogActions>
              <Buttons onClick={this.clearAllData.bind(this)} color="primary">CLEAR ALL</Buttons>
              <Buttons onClick={ () => { this.setState({ openDialog: false }) }} color="primary">Close</Buttons>
              <Buttons onClick={this.transfer.bind(this)} color="primary">Add</Buttons>
            </DialogActions>
        </Dialog>
      </div>
    );
  }
}

Transfer.propTypes = { classes: PropTypes.object.isRequired };

export default withStyles(styles)(Transfer);
